/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type SendEnterpriseAdminOnboardingEmailRequestBody = {
  /**
   * Recipient email addresses.
   */
  recipients: Array<string>;
};

/** @internal */
export type SendEnterpriseAdminOnboardingEmailRequestBody$Outbound = {
  recipients: Array<string>;
};

/** @internal */
export const SendEnterpriseAdminOnboardingEmailRequestBody$outboundSchema:
  z.ZodMiniType<
    SendEnterpriseAdminOnboardingEmailRequestBody$Outbound,
    SendEnterpriseAdminOnboardingEmailRequestBody
  > = z.object({
    recipients: z.array(z.string()),
  });

export function sendEnterpriseAdminOnboardingEmailRequestBodyToJSON(
  sendEnterpriseAdminOnboardingEmailRequestBody:
    SendEnterpriseAdminOnboardingEmailRequestBody,
): string {
  return JSON.stringify(
    SendEnterpriseAdminOnboardingEmailRequestBody$outboundSchema.parse(
      sendEnterpriseAdminOnboardingEmailRequestBody,
    ),
  );
}
